import 'select2';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'moment';
import 'daterangepicker';
import 'slick-carousel';
import '@fancyapps/fancybox';
import 'webpack-jquery-ui/sortable';
import 'webpack-jquery-ui/droppable';
import 'webpack-jquery-ui/draggable';
import 'jquery-countdown';
import 'intl-tel-input';

// import 'tinymce';
// import 'tinymce/themes/silver/theme';
// import 'tinymce/models/dom/model';
// import 'tinymce/icons/default'
// import 'tinymce/plugins/advlist/plugin';
// //import 'tinymce/plugins/advcode/plugin';
// //import 'tinymce/plugins/advtable/plugin';
// import 'tinymce/plugins/autolink/plugin';
// //import 'tinymce/plugins/checklist/plugin';
// //import 'tinymce/plugins/markdown/plugin';
// import 'tinymce/plugins/lists/plugin';
// import 'tinymce/plugins/link/plugin';
// import 'tinymce/plugins/image/plugin';
// import 'tinymce/plugins/charmap/plugin';
// import 'tinymce/plugins/preview/plugin';
// import 'tinymce/plugins/anchor/plugin';
// import 'tinymce/plugins/searchreplace/plugin';
// import 'tinymce/plugins/visualblocks/plugin';
// //import 'tinymce/plugins/powerpaste/plugin';
// import 'tinymce/plugins/fullscreen/plugin';
// //import 'tinymce/plugins/formatpainter/plugin';
// import 'tinymce/plugins/insertdatetime/plugin';
// import 'tinymce/plugins/media/plugin';
// import 'tinymce/plugins/table/plugin';
// import 'tinymce/plugins/help/plugin';
// import 'tinymce/plugins/wordcount/plugin';
// //import 'tinymce/plugins/a11ychecker/plugin';
// import 'tinymce/skins/content/default/content.css'

// import Quill from 'quill';

// import '../../node_modules/quill/dist/quill.core.css';
// import '../../node_modules/quill/dist/quill.snow.css';
import "../../node_modules/jquery-ui/themes/base/sortable.css";

import 'summernote/dist/summernote-lite.min';

document.addEventListener("DOMContentLoaded", function (event) {
    // const Quill = require("quill");
    // $('.text-editor').each(function (index) {
    //     let el = $(this).get(0);
    //     new Quill(el, {
    //         theme: 'snow',
    //         modules: {

    //               toolbar: [
    //                 ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    //                 ['blockquote', 'code-block'],

    //                 [{'header': 1}, {'header': 2}],               // custom button values
    //                 [{'list': 'ordered'}, {'list': 'bullet'}],
    //                 [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
    //                 [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
    //                 [{'direction': 'rtl'}],                         // text direction

    //                 [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
    //                 [{'header': [1, 2, 3, 4, 5, 6, false]}],

    //                 [{'color': []}, {'background': []}],          // dropdown with defaults from theme
    //                 [{'font': []}],
    //                 [{'align': []}],
    //                 ['link', 'image'],
    //             ]
    //         },
    //     });
    // });
    $('.text-editor').summernote({
        tableClassName: function()
        {
            $(this).addClass('table table-bordered').attr('cellpadding', 12)
            .attr('cellspacing', 0)
            .attr('border', 1)
            .css('borderCollapse', 'collapse');
    
            $(this).find('td')
            .css('borderColor', '#ccc')
            .css('padding', '15px');
        }
    });
    // tinymce.init({
    //     selector: '.text-editor',
    //     content_css: 'default',
    //     plugins: [
    //         'advlist','autolink',
    //         'lists','link','image','charmap','preview','anchor','searchreplace','visualblocks',
    //         'fullscreen','insertdatetime','media','table','wordcount'
    //       ],
    //     toolbar: 'undo redo | formatpainter casechange blocks | bold italic backcolor | ' +
    //       'alignleft aligncenter alignright alignjustify | ' +
    //       'bullist numlist checklist outdent indent | removeformat | a11ycheck code table help'
    //   });
    //   tinymce.init({
    //     selector: '.text-editor-content',
    //   });
});



// import Icons from 'quill/ui/icons';

import '../../node_modules/intl-tel-input/build/js/intlTelInput-jquery';
import '../../node_modules/intl-tel-input/build/css/intlTelInput.css';
import '../../node_modules/select2/dist/css/select2.css';
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../../node_modules/daterangepicker/daterangepicker.css';
import '../../node_modules/slick-carousel/slick/slick.css';
import '../../node_modules/hamburgers/dist/hamburgers.css';
//import '../../node_modules/quill/dist/quill.snow.css';
import '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import '../scss/style.scss';
import '../scss/helpers/_helpers.scss';
import '../scss/pages/_pages.scss';
import '../scss/blocks/_blocks.scss';
import '../scss/helpers/responsive.scss';
import "../../node_modules/jquery-ui/themes/base/all.css";
import 'summernote/dist/summernote-lite.min.css';

import fns from "./functions";
import importPage from './importPage';
import exportPage from './exportPage';
import importedFile from './importedFile';
import createNewAuction from "./createNewAuction";
import addLotsAuctionStep2 from './addLotsAuctionStep2';
import auctionSummary from "./auctionSummary";
import calendar from './calendar';
import initSelect2 from './initSelect2';
import userList from './usersList';
import innerProduct from './innerProduct';
import rolePermission from "./rolePermission";
import clientsList from "./clientsList";
import createNewProduct from "./createNewProduct";
import userProfile from "./userProfile";
import mainTableActions from "./mainTableActions";
import inputValidation from "./inputValidation";
import clientsInner from './clients-inner';
import auctionList from "./auction-list";
import statistic from "./statistic";
import auctionInner from "./auction-inner";
import biddingPopUp from "./bidding-popup";
import auctionInnerEnded from "./auction-inner-ended";
import needDecision from "./need-decition";
import mainActions from "./mainActions";
import customActions from "./customActions";
import socketActions from "./socketActions";
import pageEdit from "./page-edit";
import packageTable from "./packageTable";
import createUserDataField from "./createUserDataField";
import createNewService from "./createNewService";
import orderInner from "./orderInner";
import createCategoryField from "./createCategoryField";

import header from "./header";
import popupRegistration from "./popup-registration";
import filtering from "./filtering";
import frLotsInner from "./fr-lots-inner";
import bidding from "./bidding";
import footer from "./footer";
import frMainPage from './fr-mainpage';
import myBids from './fr-my-bids';
import textPage from './fr-textpage';
import frNotifications from './fr-notifications';
import frDUK from './fr-duk';
import frProfile from './fr-userProfile';
import frSettings from './fr-settings';
import frMap from './fr-map';
import timeCountDown from './timeCountDown';
import frLikes from './fr-likes';
import frRegistration from './fr-registration';

import  pageRegistration from './page-sign-up';
//import marketplaceRegistration from './seller-sign-up';

import traderMainpage from './tr-mainpage';
import newsletter from "./newsletter";

import loader from "./loader";

// EXTRAFRONT
import yourOrders from "./yourOrder";
import bidList3 from "./bid-list-3";

$(document).ready(function () {
    // const body = $('body');
    const body = $('#template-holder');

    fns.init();
    //mainTableActions.init();

    header.init();
    footer.init();
    mainActions.popupMain();

    popupRegistration.init();
    
    newsletter.newsletterValidation();

    if (body.hasClass('template-import')) {
        importPage.init();
        initSelect2.initSelectRegular();
    }

    if (body.hasClass('template-export')) {
        initSelect2.initSelectRegular();
        exportPage.init();
    }

    if (body.hasClass('template-imported-file')) {
        importedFile.init();

    }

    if (body.hasClass('template-create-new-auction')) {
        initSelect2.initSelectRegular();
        createNewAuction.init();
        initSelect2.initMultiSelectListing();
    }

    if (body.hasClass('template-add-lots')) {
        initSelect2.initSelectRegular();
        addLotsAuctionStep2.init();
        filtering.init();
        mainActions.tablePaginationInput();
        packageTable.init();
        mainActions.reorderTable();
        customActions.tableScrips();
    }

    if (body.hasClass('template-auction-summary')) {
        auctionSummary.init();
        initSelect2.initSelectRegular();
        customActions.tableScrips();
    }

    if (body.hasClass('template-calendar')) {
        calendar.init();
        initSelect2.initSelectRegular();
    }

    if (body.hasClass('template-calendar-week')) {
        initSelect2.initSelectRegular();
        calendar.monthViewCreateDropToggle();
    }

    if (body.hasClass('template-calendar-day')) {
        initSelect2.initSelectRegular();
        calendar.dayViewActionsToggle();
    }

    if (body.hasClass('template-users-list')) {
        initSelect2.initSelectRegular();
        userList.init();
        customActions.tableScrips();
    }

    if (body.hasClass('template-clients-list')) {
        initSelect2.initSelectRegular();
        clientsList.init();
    }

    if (body.hasClass('template-inner-product')) {
        innerProduct.init();
    }

    if (body.hasClass('template-edit-role-permissions')) {
        rolePermission.init();
    }

    if (body.hasClass('template-user-details')) {
        initSelect2.initSelectRegular();
        userProfile.init();
        mainActions.tableTabToggle();
        customActions.tableScrips();
        mainActions.dateRangePicker();
        inputValidation.validationEmail();
        inputValidation.validationPhone();
        createNewProduct.init();
    }

    if (body.hasClass('template-create-new-product')) {
        initSelect2.initSelectRegular();
        createNewProduct.init();
        mainActions.uploadMultiImage();
        mainActions.uploadMultiEdit();
        mainActions.dateRangePicker();
        customActions.productScripts();
        customActions.userRoleScripts();
        customActions.globalSettingsScripts();
    }

    if (body.hasClass('fr-auction-inner')) {
        initSelect2.initSelectRegular();
        filtering.init();
        bidding.init();
        timeCountDown.init();
        frLikes.initAuctionLike();
        frLikes.initLotsCardLikes();
        frLikes.auctionCardSlideDownMore();
    }

    if (body.hasClass('fr-lots-inner')) {
        frLotsInner.init();
        bidding.init();
        timeCountDown.init();
        frLikes.initLotsCardLikes();
        socketActions.socketScrips();
        frLikes.auctionCardSlideDownMore();
        customActions.innerLotScripts();
    }

    if (body.hasClass('fr-category')) {
        initSelect2.initSelectRegular();
        filtering.init();
        bidding.init();
        frLikes.initLotsCardLikes();
        timeCountDown.init();
        frLikes.auctionCardSlideDownMore();
    }

    if (body.hasClass('fr-mainpage')) {
        frMainPage.init();
        timeCountDown.init();
        frLikes.initLotsCardLikes();
        frLikes.auctionCardSlideDownMore();
        frLikes.initAuctionCardLikes();
    }

    if (body.hasClass('fr-my-bids')) {
        initSelect2.initSelectRegular();
        filtering.init();
        timeCountDown.init();
        bidding.init();
        frLikes.initLotsCardLikes();
        myBids.init();
        socketActions.socketScrips();
        customActions.marketplaceScrips();
    }

    if (body.hasClass('fr-my-favorite')) {
        initSelect2.initSelectRegular();
        filtering.init();
        timeCountDown.init();
        frLikes.initLotsCardLikes();
        frLikes.initAuctionCardLikes();
        frLikes.auctionCardSlideDownMore();
    }

    if (body.hasClass('fr-user-profile')) {
        initSelect2.initSelectRegular();
        mainActions.dateRangePicker();
        inputValidation.validationEmail();
        inputValidation.validationPhone();
        frProfile.init();
        createNewProduct.init();
    }

    if (body.hasClass('fr-text-page')) {
        textPage.initFullImageTextSlider();
        textPage.initImageSlider();
        initSelect2.initSelectRegular();
    }

    if (body.hasClass('fr-search-results')) {
        frLikes.initLotsCardLikes();
        frLikes.auctionCardSlideDownMore();
    }

    if (body.hasClass('fr-notifications')) {
        frNotifications.init();
    }

    if (body.hasClass('fr-duk')) {
        frDUK.init();
        inputValidation.validationEmail();
    }

    if (body.hasClass('fr-settings')) {
        initSelect2.initSelectRegular();
        frSettings.init();
    }

    if (body.hasClass('fr-news')) {
        initSelect2.initSelectRegular();
    }

    if (body.hasClass('fr-duk')) {
        initSelect2.initSelectRegular();
    }

    if (body.hasClass('fr-duk')) {
        initSelect2.initSelectRegular();
    }

    if (body.hasClass('fr-contacts')) {
        frMap.initMap();
    }

    if (body.hasClass('template-bids-list')) {
        initSelect2.initSelectRegular();
        mainTableActions.init();
    }

    if (body.hasClass('template-client-info')) {
        initSelect2.initSelectRegular();
        statistic.init();
        mainTableActions.init();
        clientsInner.init();
    }

    if(body.hasClass('template-auction-inner')){
        initSelect2.initSelectRegular();
        createNewAuction.init();
        mainTableActions.init();
        biddingPopUp.init();
        auctionInner.init();
        customActions.tableScrips();
    }

    if(body.hasClass('template-auction-inner')&&body.hasClass('ended') ){
        auctionInnerEnded.init();
    }

    if(body.hasClass('need-decision')){
        needDecision.init();
    }

     if(body.hasClass('template-notifications')){
         frNotifications.init();
     }

    if(body.hasClass('template-clients-logs')){
        initSelect2.initSelectRegular();
        mainTableActions.init();
    }

    if(body.hasClass('template-clients-logs')){
        initSelect2.initSelectRegular();
        mainTableActions.init();
    }

    if(body.hasClass('tr-seller-sign-up')){
        initSelect2.initSelectRegular();
        pageRegistration.init();
    }

    if(body.hasClass('tr-main')){
        traderMainpage.init();
    }

    if(body.hasClass('tr-marketplace-sign-up')) {
        initSelect2.initSelectRegular();
        pageRegistration.init();
    }

    if(body.hasClass('fr-pack-inner')) {
        filtering.init();
        bidding.init();
        timeCountDown.init();
        frLikes.initLotsCardLikes();
        frLikes.auctionCardSlideDownMore();
    }

    if(body.hasClass('fr-order-inner')) {
        initSelect2.initSelectRegular();
    }

    if(body.hasClass('template-create-newsletter')) {
        mainActions.TextEditor();
        mainActions.upload1Image();
        mainActions.DragAndDrop1ImageUpload();
    }

    if(body.hasClass('template-page-edit')) {
        pageEdit.init();
        mainActions.TextEditor();
        mainActions.upload1Image();
        mainActions.DragAndDrop1ImageUpload();
        customActions.builderScrips();
    }

    if(body.hasClass('template-settings')) {
        initSelect2.initSelectRegular();
        mainActions.upload1Image();
        customActions.globalSettingsScripts();
    }

    if(body.hasClass('template-departments')) {
        initSelect2.initSelectRegular();
    }

    if(body.hasClass('template-roles')) {
        initSelect2.initSelectRegular();
    }

    if(body.hasClass('template-permissions')) {
        initSelect2.initSelectRegular();
    }

    if(body.hasClass('template-create-departments')) {
        initSelect2.initSelectRegular();
        mainActions.uploadMultiImage();
        mainActions.uploadMultiEdit();
        mainActions.tableTabToggle();
    }

    if(body.hasClass('template-login-page')) {
        mainActions.TextEditor();
        mainActions.upload1Image();
        mainActions.DragAndDrop1ImageUpload();
    }

    if(body.hasClass('template-user-data')) {
        initSelect2.initSelectRegular();
        // mainActions.reorderTable();
        customActions.tableScrips();
        customActions.userFieldScripts();
    }

    if(body.hasClass('template-billing-fields')) {
        initSelect2.initSelectRegular();
        customActions.tableScrips();
    }

    if(body.hasClass('template-shipping-fields')) {
        initSelect2.initSelectRegular();
    }

    if(body.hasClass('template-authorization-level')) {
        initSelect2.initSelectRegular();
    }

    if(body.hasClass('template-verification')) {
        initSelect2.initSelectRegular();
    }

    if(body.hasClass('template-subscribers')) {
        initSelect2.initSelectRegular();
    }

    if(body.hasClass('template-new-billing-field')) {
        initSelect2.initSelectRegular();
        initSelect2.initMultiSelectListing();
    }

    if(body.hasClass('template-create-authorization-level')) {
        initSelect2.initSelectRegular();
        initSelect2.initMultiSelectListing();
        mainActions.rulesFormToggle();

    }

    if(body.hasClass('template-stock')) {
        initSelect2.initSelectRegular();
        customActions.tableScrips();
        customActions.stockScripts();
    }

    if(body.hasClass('template-orders')) {
        initSelect2.initSelectRegular();
    }

    if(body.hasClass('template-create-new-user-data-field')) {
        initSelect2.initSelectRegular();
        initSelect2.initMultiSelectListing();
        createUserDataField.init();
    }

    if(body.hasClass('template-create-price-type')) {
        initSelect2.initSelectRegular();
        initSelect2.initMultiSelectListing();
        customActions.priceTypeScripts();
    }

    if(body.hasClass('template-order-inner')) {
        initSelect2.initSelectRegular();
        orderInner.init();
    }

    if(body.hasClass('template-create-new-order')) {
        initSelect2.initSelectRegular();
        filtering.init();
        customActions.tableScrips();
    }

    if(body.hasClass('template-packages')) {
        initSelect2.initSelectRegular();
    }

    if(body.hasClass('template-category')) {
        initSelect2.initSelectRegular();
    }

    if(body.hasClass('template-category-fields')) {
        initSelect2.initSelectRegular();
        mainActions.reorderTable();
    }

    if(body.hasClass('template-create-category')) {
        initSelect2.initSelectRegular();
        initSelect2.initMultiSelectListing();
        mainActions.subSelectDrop();
        customActions.tableScrips();
        customActions.editCategoryScrips();
    }

    if(body.hasClass('template-create-category-fields')) {
        initSelect2.initSelectRegular();
        initSelect2.initMultiSelectListing();
        customActions.categoryFieldScripts();
    }

    if(body.hasClass('template-product-list')) {
        initSelect2.initSelectRegular();
        filtering.init();
        customActions.tableScrips();
    }

    if(body.hasClass('template-create-new-package')) {
        initSelect2.initSelectRegular();
        filtering.init();
    }

    if(body.hasClass('template-import-history')) {
        initSelect2.initSelectRegular();
    }

    if(body.hasClass('template-export-history')) {
        initSelect2.initSelectRegular();
    }

    if(body.hasClass('template-auctions-list')){
        auctionList.init();
        initSelect2.initSelectRegular();
        mainTableActions.init();
        mainActions.dateRangePicker();
        customActions.tableScrips();
    }

    if(body.hasClass('template-winner')) {
        initSelect2.initSelectRegular();
    }

    if(body.hasClass('template-after-imported')) {
        initSelect2.initSelectRegular();
        mainTableActions.init();
        packageTable.init();
        mainActions.reorderTable();
    }

    if(body.hasClass('template-create-new-service')) {
        initSelect2.initSelectRegular();
        createNewService.init();
        initSelect2.initMultiSelectListing();
        customActions.serviceScripts();
    }

    if(body.hasClass('template-create-category-fields')){
        //createCategoryField.init();
    }

    if(body.hasClass('template-your-orders')){
        yourOrders.init();
    }

    if(body.hasClass('template-bids-list-3')){
        bidList3.init();
    }

    if(body.hasClass('fr-registration')){
        if(body.hasClass('cl-log-in')){
            initSelect2.initSelectRegular();
            createNewProduct.init();
            mainActions.dateRangePicker();
            inputValidation.validationEmail();
            inputValidation.validationPhone();
            frRegistration.init();
        }
    }

    if(body.hasClass('template-restriction-notice')){
        customActions.restrictionNoticeScripts();
    }

    if(body.hasClass('template-email-template')){
        customActions.emailTemplateScripts();
    }

    if(body.hasClass('template-custom-email-template')){
        customActions.customEmailTemplateScripts();
    }

    if(body.hasClass('template-deeealer-data-mapping-field-options')){
        customActions.deeealerDataMappingFieldOptionsScripts();
    }

    if(body.hasClass('template-offer')){
        customActions.offerScripts();
    }
});

